/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */

/**
 * Import stylesheet
 */
import $ from 'jquery';
import slick from 'slick-carousel';
import '../scss/main.scss';
import MiniCart from "./functions/MiniCart";

$(document).ready(function () {
    const cookiesPopupElement = document.getElementById("cookiesPopup");

    if (cookiesPopupElement) {
        const closeBtn = cookiesPopupElement.querySelector('.cookies__close-btn');

        if (closeBtn) {
            closeBtn.addEventListener('click', function (e) {
                e.preventDefault()
                const cookieExpiry = 30;
                const cookiePath = "/";
                createCookie('seen-cookiePopup', 'yes', cookieExpiry, cookiePath);
                cookiesPopupElement.classList.add('cookies--close')
            });
        }

        const cookiePopup = readCookie('seen-cookiePopup');

        if (cookiePopup != null && cookiePopup == 'yes') {
            console.log(cookiesPopupElement)
            cookiesPopupElement.classList.add('cookies--close')
        } else {
            cookiesPopupElement.classList.remove('cookies--close')
        }
    }

    customInputNumberEvents()

    let productCarousel = $('#productsCarousel')
    let productCarouselNav = $('#productsCarouselNav')
    if (productCarousel.length > 0) {
        productCarousel.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            infinite: true,
            asNavFor: '#productsCarouselNav',
            responsive: [
                {
                    breakpoint: 990,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        fade: false,
                        infinite: true,
                        dots: true,
                        asNavFor: false,
                    }
                }
            ]
        })
    }
    if (productCarouselNav.length > 0) {
        productCarouselNav.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '#productsCarousel',
            dots: false,
            arrows: false,
            centerMode: false,
            vertical: true,
            verticalSwiping: true,
            infinite: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 1,
                        infinite: true,
                        centerMode: true,
                        centerPadding: 15,
                        vertical: false,
                        verticalSwiping: false,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        infinite: true,
                        centerMode: true,
                        centerPadding: 15,
                        vertical: false,
                        verticalSwiping: false,
                    }
                },
                {
                    breakpoint: 400,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        centerMode: true,
                        centerPadding: 15,
                        vertical: false,
                        verticalSwiping: false,
                    }
                }
            ]
        })
    }


    checkoutActions();
    refreshFragment()
    openSearchBar();
    initHeaderSlider();
    initOpinionsSlider();
    initMobileMegaMenu();
    initSlickForInfoBar();
    new MiniCart;

})


function createCookie(name, value, days, path) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else expires = "";
    document.cookie = name + "=" + value + expires + "; path=" + path;
}

function readCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}


function customInputNumberEvents(containerClassName) {
    let currentValue = 0;

    $('body').on('click', '.custom-number-input > .custom-number-input__counter-down', (e) => {
        const input = $(e.target).siblings('input')
        currentValue = input.val()
        input.data('prevVal', currentValue)
        if (currentValue > 1) {
            currentValue--
            console.log(input)
            input.val(currentValue).trigger('change')
        }
    })
    $("body").on('click', '.custom-number-input > .custom-number-input__counter-up', (e) => {
        const input = $(e.target).siblings('input')
        currentValue = input.val()
        input.data('prevVal', currentValue)
        currentValue++
        input.val(currentValue).trigger('change')
    })
}

function checkoutActions() {
    $('#goToPayment').click(function () {
        $('#step1').addClass('d-none')
        $('#step2').removeClass('d-none')
    })

    if ($('.checkout')) {
        $('a[data-step="1"]').click(function (e) {
            e.preventDefault()
            $('#step1').removeClass('d-none')
            $('#step2').addClass('d-none')
        })
    }
    if ($('.checkout')) {
        $('a[data-step="2"]').click(function (e) {
            e.preventDefault()
            $('#step1').addClass('d-none')
            $('#step2').removeClass('d-none')
        })
    }
}

function refreshFragment() {
    $(document).ajaxComplete(function (event, request, settings) {
        if (
            settings.url === "/?wc-ajax=get_refreshed_fragments" ||
            settings.url === "/?wc-ajax=update_order_review" ||
            settings.url === "/?wc-ajax=update_shipping_method"
        ) {
            const cartContent = $('.js-miniCartContent')

            fetch(window.global.ajax_url + "?action=refreshCart", {
                method: "POST", //* GET, POST, PUT, DELETE, etc.
                mode: "cors", // no-cors, *cors, same-origin
                cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
                credentials: "same-origin", // include, *same-origin, omit
                headers: {
                    // "Content-Type": "application/json",
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                redirect: "follow", // manual, *follow, error
                referrerPolicy: "no-referrer", // no-referrer, *client
                body: new URLSearchParams({
                    security: window.global.security,
                }),
            })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.success) {
                        if (data.data.cart_content) {
                            cartContent.empty().append(data.data.cart_content)
                        }
                    }
                })
                .finally(() => {
                    parent.removeClass('small-cart-item--loader')
                })
        }
    });
}

function openSearchBar() {
    $('.js-openSearchbar').click((e) => {
        e.preventDefault()

        $('.searchbar').toggleClass('searchbar--open')

    })
}

let headerSliderTimeout = null

function initHeaderSlider() {
    let headerSlider = $('.js-header-slider')
    if (headerSlider.length > 0) {
        headerSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            fade: true,
            infinite: true,
            autoplay: true,
            speed: 800,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        adaptiveHeight: true
                    }
                }
            ]
        })

        // Handle video playback after slide changes
        headerSlider.on('afterChange', function (event, slick, currentSlide) {
            handleSlideVideo(slick, currentSlide)
        })

        // Start first slide
        headerSlider.on('init', function (event, slick) {
            setTimeout(function () {
                handleSlideVideo(slick, slick.currentSlide)
            }, 500)
        })

        headerSlider.slick('slickGoTo', 0)
    }
}

function handleSlideVideo(slick, slideIndex) {
    console.log('handleSlideVideo - slideIndex:', slideIndex)

    // Clear any existing timeout
    if (headerSliderTimeout) {
        clearTimeout(headerSliderTimeout)
        headerSliderTimeout = null
    }

    // Pause and reset all videos
    $('.js-header-slider video').each(function () {
        this.pause()
        this.currentTime = 0
    })

    // Get the current slide - slick wraps slides, so we need to find the actual content
    const $currentSlide = $(slick.$slides[slideIndex])
    const $slideContent = $currentSlide.find('.header__slider')
    const slideType = $slideContent.attr('data-slide-type')
    const $video = $slideContent.find('video')

    console.log('Current slide:', {
        slideIndex: slideIndex,
        slideType: slideType,
        hasVideo: $video.length > 0
    })

    if (slideType === 'video' && $video.length > 0) {
        const video = $video[0]

        console.log('Playing video, duration:', video.duration)

        // Try to play video
        const playPromise = video.play()

        if (playPromise !== undefined) {
            playPromise.then(function () {
                console.log('Video started playing successfully')
            }).catch(function (error) {
                console.error('Video play failed:', error)
                // If video fails to play, advance after 5 seconds
                headerSliderTimeout = setTimeout(function () {
                    slick.slickNext()
                }, 5000)
            })
        }

        // Remove old event listeners to avoid duplicates
        $(video).off('ended')

        // Add event listener for when video ends
        $(video).on('ended', function () {
            console.log('Video ended, advancing to next slide')
            slick.slickNext()
        })

    } else {
        console.log('Image slide, auto-advance in 5 seconds')
        // For image slides, auto-advance after 5 seconds
        headerSliderTimeout = setTimeout(function () {
            slick.slickNext()
        }, 5000)
    }
}

function initOpinionsSlider() {
    let opinionsSlider = $('.opinions-slider')
    if (opinionsSlider.length > 0) {
        opinionsSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            fade: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 4000,
            speed: 800
        })
    }
}

function initMobileMegaMenu() {
    // Listen to Bootstrap navbar collapse events
    $('.navbar-collapse').on('show.bs.collapse', function () {
        // Disable body scroll when navbar opens
        $('body').css('overflow', 'hidden')
    })

    $('.navbar-collapse').on('hide.bs.collapse', function () {
        // Enable body scroll when navbar closes (only if no mega menu is open)
        if (!$('.mega-menu.is-active').length) {
            $('body').css('overflow', '')
        }
    })

    // Open mega menu on mobile
    $('.js-megamenu-toggle').on('click', function (e) {
        // Only prevent default and open mega menu on mobile
        if ($(window).width() < 1200) {
            e.preventDefault()
            e.stopPropagation()

            const $megaMenu = $(this).siblings('.mega-menu')
            const $mainMenu = $(this).closest('.navbar')

            // Open mega menu
            $megaMenu.addClass('is-active')

            // Add class to wrapper to hide hamburger
            $('.mobile-menu-wrapper').addClass('megamenu-open')

            // Disable body scroll
            $('body').css('overflow', 'hidden')

            // Disable main menu content
            $mainMenu.find('.nav-list__item').not($(this).parent()).css('pointer-events', 'none')
        }
        // On desktop, allow normal link behavior (navigate to href)
    })

    // Close mega menu - back button
    $('.js-megamenu-back').on('click', function (e) {
        e.preventDefault()
        closeMegaMenu($(this).closest('.mega-menu'))
    })

    // Close mega menu - close button
    $('.js-megamenu-close').on('click', function (e) {
        e.preventDefault()
        const $megaMenu = $(this).closest('.mega-menu')
        closeMegaMenu($megaMenu)

        // Also close the main mobile menu if exists
        const $navbarCollapse = $(this).closest('.navbar-collapse')
        if ($navbarCollapse.hasClass('show')) {
            $navbarCollapse.collapse('hide')
        }
    })

    function closeMegaMenu($megaMenu) {
        // Close mega menu
        $megaMenu.removeClass('is-active')

        // Remove class from wrapper to show hamburger
        $('.mobile-menu-wrapper').removeClass('megamenu-open')

        // Enable body scroll (only if navbar is not open)
        if (!$('.navbar-collapse').hasClass('show')) {
            $('body').css('overflow', '')
        }

        // Enable main menu content
        $('.nav-list__item').css('pointer-events', '')
    }
}

function initSlickForInfoBar() {
    const infoBoxContainer = $('#infoBox')
    if (!infoBoxContainer) return;

    infoBoxContainer.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        fade: false,
        infinite: true,
    })
}
